import moment from 'moment'
import {startDate, endDate } from "../env.js";
require('moment-duration-format')
moment.locale('ja')
console.log('momentLoad')
export default {
  methods: {
    scheduleLinkFormat: function() {
      var today = moment(new Date()).format("YYYY-MM-DD");
      if (moment(today).isBefore(startDate)) {
        return startDate;
      } else if (moment(today).isAfter(endDate)) {
        return endDate;
      } else {
        return today;
      }
    },
    daysDiff: function(from, to) {
      return moment(to).diff(from, "days");
    },
    addDays: function(from,plus){
      return moment(from)
        .add(plus, "days")
        .format("YYYY-MM-DD");
    }
    ,
    addDatetime: function (from, plus) {
      return moment(from)
        .add(plus, "days")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  },
  filters: {
    datedayformat(value) {
      return (
        moment(value).format("MM/DD") +
        "[" +
        moment(value)
          .locale("en")
          .format("ddd")
          .toUpperCase() +
        "]"
      );
    },
    dateformat(value) {
      return moment(value).format("MM/DD");
    },
    datedotformat(value) {
      return moment(value).format("MM.DD");
    },
    datedotformatGuest(value) {

      if (moment(value).format("D") == 1 || moment(value).format("YYYY-MM-DD") == startDate ){
        return moment(value).format("MM.D");
      } else {
        return moment(value).format("D");
      }
      
    },
    dateidformat(value) {
      return "date" + moment(value).format("DD");
    },
    dateidformatHash(value) {
      return "#date" + moment(value).format("DD");
    },
    dayformat(value) {
      return moment(value)
        .locale("en")
        .format("ddd")
        .toUpperCase();
    },
    dayformatClass(value) {
      return moment(value)
        .locale("en")
        .format("ddd")
        .toLowerCase();
    },
    timeformat(value) {
      return moment.duration(value, "ms").format("H:mm", { trim: false });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/momentFormat.js